// Operation — VROC-компонент страницы оперативного контроля

export class Operation {
	constructor() {
		this.componentId = 'operation';
		this._register();
	}

	_register() {
		const container = document.querySelector('.page.operation');
		if (!container) return;

		window.vroc.attachComponent({
			id: this.componentId,
			node: '.page.operation',
			attach: true
		});

		console.log('[Operation] Attached');
	}

	/**
	 * Обновление страницы — запрашивает свежий HTML и morphdom-патчит DOM
	 */
	async update() {
		try {
			const params = new URLSearchParams(window.location.search);
			params.set('action', 'loadOperation');
			params.set('view', 'operation');

			const response = await window.ajax.post('/ajax.php?mid=47', Object.fromEntries(params), { dataType: 'html' });
			await window.vroc.updateComponent(this.componentId, response);
		} catch (error) {
			console.error('[Operation] Update error:', error);
		}
	}

	// ─── Filter setters: update URL params and reload ─────────────────

	_setParam(name, value) {
		const url = new URL(window.location.href);
		if (value === '' || value === null || value === undefined) {
			url.searchParams.delete(name);
		} else {
			url.searchParams.set(name, value);
		}
		window.location.href = url.toString();
	}

	setMode(mode) {
		const url = new URL(window.location.href);
		url.searchParams.set('mode', mode);
		// Reset mode-specific filters
		url.searchParams.delete('statuses');
		url.searchParams.delete('types');
		url.searchParams.delete('contractors');
		url.searchParams.delete('contractorSearch');
		window.location.href = url.toString();
	}

	setDateField(field) {
		this._setParam('dateField', field);
	}

	setPreset(preset) {
		this._setParam('preset', preset);
	}

	setGroupBy(groupBy) {
		this._setParam('groupBy', groupBy);
	}

	// Click on alert — sets/clears sticky scope, preserves other filters
	setScope(scope) {
		const url = new URL(window.location.href);
		const current = url.searchParams.get('scope') || '';
		if (current === scope)
			url.searchParams.delete('scope');
		else
			url.searchParams.set('scope', scope);
		window.location.href = url.toString();
	}

	toggleType(type) {
		this._toggleMulti('types', type);
	}

	toggleStatus(status) {
		this._toggleMulti('statuses', status);
	}

	_toggleMulti(name, value) {
		const url = new URL(window.location.href);
		const current = (url.searchParams.get(name) || '').split(',').filter(Boolean);
		const idx = current.indexOf(value);
		if (idx >= 0) current.splice(idx, 1);
		else current.push(value);

		if (current.length === 0) url.searchParams.delete(name);
		else url.searchParams.set(name, current.join(','));

		window.location.href = url.toString();
	}

	// ─── Contractor filter ─────────────────────────────────────────────

	_getContractorDropdown() {
		return document.querySelector('.operation__filter-contractor-dropdown');
	}

	filterContractors(inputEl) {
		const value = inputEl.value.trim();
		const dropdown = this._getContractorDropdown();

		if (!value) {
			if (dropdown) dropdown.innerHTML = '';
			return;
		}

		clearTimeout(this._contractorSearchTimer);
		this._contractorSearchTimer = setTimeout(async () => {
			try {
				const results = await window.ajax.post('/ajax.php?mid=47', {
					action: 'searchContractors',
					q: value
				});
				const dropdown = this._getContractorDropdown();
				if (!dropdown) return;

				if (!results || !results.length) {
					dropdown.innerHTML = '<div class="operation__filter-contractor-empty">Nothing found</div>';
					return;
				}

				dropdown.innerHTML = results.map(r =>
					`<a class="operation__filter-contractor-option" href="javascript:void(0)" onmousedown="operation.addContractor(${r.id}, event)">${r.name}</a>`
				).join('');
			} catch (e) {
				console.error('[Operation] Contractor search error:', e);
			}
		}, 250);
	}

	addContractor(id, mouseEvent) {
		// mousedown fires before blur — prevent input blur from clearing dropdown first
		if (mouseEvent) mouseEvent.preventDefault();

		const url = new URL(window.location.href);
		const current = (url.searchParams.get('contractors') || '').split(',').filter(Boolean);
		if (!current.includes(String(id))) current.push(String(id));
		url.searchParams.set('contractors', current.join(','));
		window.location.href = url.toString();
	}

	removeContractor(id) {
		const url = new URL(window.location.href);
		const current = (url.searchParams.get('contractors') || '').split(',').filter(Boolean);
		const filtered = current.filter(v => v !== String(id));
		if (filtered.length === 0) url.searchParams.delete('contractors');
		else url.searchParams.set('contractors', filtered.join(','));
		window.location.href = url.toString();
	}

	hideContractorDropdown() {
		// Small delay so mousedown on an option fires before blur clears dropdown
		setTimeout(() => {
			const dropdown = this._getContractorDropdown();
			if (dropdown) dropdown.innerHTML = '';
		}, 150);
	}

	// ─── Mode 1: invoice row expansion ─────────────────────────────────

	async toggleInvoice(invoiceId) {
		const inv = document.querySelector(`.operation__inv[data-id="${invoiceId}"]`);
		if (!inv) return;

		const isExpanded = inv.classList.contains('operation__inv--expanded');

		if (isExpanded) {
			inv.classList.remove('operation__inv--expanded');
			return;
		}

		inv.classList.add('operation__inv--expanded');

		const timelineEl = inv.querySelector('.operation__inv-timeline');
		if (!timelineEl || timelineEl.dataset.loaded === '1') return;

		try {
			const html = await window.ajax.post('/ajax.php?mid=47', {
				action: 'loadOperationTimeline',
				id: invoiceId
			}, { dataType: 'html' });

			timelineEl.innerHTML = html;
			timelineEl.dataset.loaded = '1';
		} catch (error) {
			console.error('[Operation] Timeline load error:', error);
			timelineEl.innerHTML = '<div class="operation__timeline-empty">Failed to load</div>';
		}
	}

	// ─── Invoice tooltip (Quick view in By Services) ──────────────────

	async showInvoiceTooltip(invoiceId, anchorEl) {
		this._hideInvoiceTooltip();

		const html = await window.ajax.post('/ajax.php?mid=47', {
			action: 'loadInvoiceTooltip',
			id: invoiceId
		}, { dataType: 'html' });

		const wrapper = document.createElement('div');
		wrapper.className = 'invoice-tooltip-wrapper';
		wrapper.innerHTML = html;
		document.body.appendChild(wrapper);

		// Position near anchor
		const rect = anchorEl.getBoundingClientRect();
		const tooltipW = wrapper.offsetWidth;
		let left = rect.left + window.scrollX;
		// Avoid overflow on the right
		if (left + tooltipW > window.innerWidth - 8)
			left = window.innerWidth - tooltipW - 8;
		wrapper.style.left = left + 'px';
		wrapper.style.top = (rect.bottom + window.scrollY + 4) + 'px';

		this._invoiceTooltip = wrapper;

		// Dismiss on outside click
		setTimeout(() => {
			this._invoiceTooltipDismiss = (e) => {
				if (!wrapper.contains(e.target)) this._hideInvoiceTooltip();
			};
			document.addEventListener('click', this._invoiceTooltipDismiss);
		}, 0);
	}

	_hideInvoiceTooltip() {
		if (this._invoiceTooltip) {
			this._invoiceTooltip.remove();
			this._invoiceTooltip = null;
		}
		if (this._invoiceTooltipDismiss) {
			document.removeEventListener('click', this._invoiceTooltipDismiss);
			this._invoiceTooltipDismiss = null;
		}
	}

	// ─── Mode 2: open costing popup ────────────────────────────────────

	openCostingRow(table, serviceId, invoiceId) {
		if (window.crm) {
			window.crm.invoiceId = invoiceId;
			window.crm.openCosting(table, serviceId);
		}
	}

	// Read-only service view popup (from By Invoice timeline)
	async openServiceView(table, serviceId, invoiceId) {
		try {
			const html = await window.ajax.post('/ajax.php?mid=47', {
				action: 'loadServiceView',
				table: table,
				id: serviceId
			}, { dataType: 'html' });

			// Remember invoiceId so popup-costing knows context when Edit costing is clicked
			if (window.crm) window.crm.invoiceId = invoiceId;

			// Insert or replace the popup root in DOM
			const selector = '.popup-service-view-popup';
			const existing = document.querySelector(selector);
			const temp = document.createElement('div');
			temp.innerHTML = html.trim();
			const newEl = temp.firstElementChild;
			if (!newEl) return;

			if (existing) {
				existing.replaceWith(newEl);
			} else {
				document.body.appendChild(newEl);
			}

			window.popupManager.bindPopupEvents(newEl);
			requestAnimationFrame(() => {
				window.popupManager.open('service-view');
			});
		} catch (e) {
			console.error('[Operation] openServiceView error:', e);
		}
	}

	destroy() {
		window.vroc.detachComponent(this.componentId);
	}
}
